import 'react-loading-skeleton/dist/skeleton.css';
import React from 'react';
import Lottie from 'lottie-react';
import LoadingAnimation from '../../../animations/loading_lottie_anim.json';
import 'react-loading-skeleton/dist/skeleton.css';

const LoadingScreen: React.FC = () => {
    return <Lottie animationData={LoadingAnimation} loop={true} />;
};

export default LoadingScreen;
